<template>
  <div>
    <!-- Section Title -->
    <drop-down-menu-item :type="'title'">
      {{ sectionContent.title }}
    </drop-down-menu-item>

    <!-- FAQ's -->
    <drop-down-menu-item
      :type="'routerLink'"
      :link-to="faqsNavigationLink"
    >
      {{ sectionContent.faqs }}
    </drop-down-menu-item>

    <!-- Contact Us -->
    <template v-if="isContactUsEnabled">
      <drop-down-menu-item
        v-if="merchant.options.contact && merchant.options.contact.externalUrl"
        :type="'link'"
        :href="merchant.options.contact.externalUrl"
      >
        {{ sectionContent.contactUs }}
      </drop-down-menu-item>

      <drop-down-menu-item
        v-else-if="merchant.options.contact"
        :type="'routerLink'"
        :link-to="contactUsNavigationLink"
      >
        {{ sectionContent.contactUs }}
      </drop-down-menu-item>
    </template>

    <!-- Terms and Conditions -->
    <drop-down-menu-item
      :type="'button'"
      @click="openTermsAndConditionsClickHandler"
    >
      {{ sectionContent.termsAndConditions }}
    </drop-down-menu-item>

    <!-- Privacy Pollicy -->
    <drop-down-menu-item
      :type="'button'"
      @click="openPrivacyPolicyClickHandler"
    >
      {{ sectionContent.privacyPolicy }}
    </drop-down-menu-item>

    <!-- IOS Download -->
    <drop-down-menu-item
      v-if="isIOS_DownloadEnabled"
      :type="'link'"
      :href="merchant.features.iosUrl"
    >
      {{ sectionContent.iosDownload }}
    </drop-down-menu-item>

    <!-- Android Download -->
    <drop-down-menu-item
      v-if="isAOS_DownloadEnabled"
      :type="'link'"
      :href="merchant.features.aosUrl"
    >
      {{ sectionContent.aosDownload }}
    </drop-down-menu-item>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import DropDownMenuItem from '../drop-down-menu-item/index.vue';


  export default {
    name: 'SupportNavigation',

    components: {
      DropDownMenuItem
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['loyaltyOptions', 'merchant']),

      sectionContent() {
        const content = this.content.MenuDropdown.metadata;

        return {
          title: content.titleSupport,
          faqs: content.itemFaqs,
          contactUs: content.itemContactUs,
          termsAndConditions: content.itemTermsAndConditions,
          privacyPolicy: content.itemPrivacyPolicy,
          iosDownload: 'Download our app for iOS',
          aosDownload: 'Download our app for Android'
        };
      },

      faqsNavigationLink() {
        return { name: 'faqs' };
      },

      isContactUsEnabled() {
        return !this.merchant.options.disableContactUsLink;
      },

      contactUsNavigationLink() {
        return { name: 'contactUs' };
      },

      isIOS_DownloadEnabled() {
        return !!this.merchant.features.iosUr?.length;
      },

      isAOS_DownloadEnabled() {
        return !!this.merchant.features.aosUrl?.length;
      }
    },

    methods: {
      openTermsAndConditionsClickHandler() {
        this.$openModal('termsAndConditions');
      },

      openPrivacyPolicyClickHandler() {
        this.$openModal('privacyPolicy');
      }
    }
  };
</script>
